import { Button, Icons, toast } from "@/components/ui";
import { Tooltip } from "@/components/ui/Tooltip";
import { useMarkUnsolicitedResolved } from "../../network/useMarkUnsolicitedResolved";

export const MarkResolved = ({
  diagnosticReportId,
  disabled = false,
  disabledReason,
  patientId = "",
}: {
  diagnosticReportId: string;
  disabled?: boolean;
  disabledReason?: string | null;
  patientId?: string;
}) => {
  const { mutate: markUnsolicitedResolved, isPending: isMarkingResolved } =
    useMarkUnsolicitedResolved({
      patientId,
      diagnosticReportId,
      onError: () => {
        toast.error(
          "Failed to mark unsolicited diagnostic report as resolved.",
        );
      },
    });

  const tooltipText = disabled && disabledReason ? disabledReason : "Resolve";

  return (
    <Tooltip tooltipContentText={tooltipText} triggerClassName="h-6">
      <Button
        size="sm"
        variant="link"
        onClick={() => {
          markUnsolicitedResolved();
        }}
        isLoading={isMarkingResolved}
        disabled={disabled}
      >
        <Icons.Check />
      </Button>
    </Tooltip>
  );
};
